import axios from 'axios';

//BASE ADDRESS: https://api.themoviedb.org/3
//URL GET LIST: movie/now_playing?api_key=b2a3e8308a02cf82c6c80dddbcbfae6e&language=pt-BR

const api = axios.create({
    baseURL: 'https://api.themoviedb.org/3/'
});

export default api;